export const CREATIVE_TYPE_OPTIONS = [
    { name: '图片jpg', value: 1 },
    { name: '图片png', value: 2 },
    { name: '图片gif', value: 3 },
    { name: 'flash文件', value: 4 },
    { name: '视频mp4', value: 5 },
    { name: '视频flv', value: 6 },
    { name: '文字', value: 7 },
    { name: '图文', value: 8 },
    { name: '动态创意', value: 9 }
];
export const OS_TYPE_OPTIONS = [
    { name: 'iOS', value: 1 },
    { name: 'Android', value: 2 },
    { name: 'WP', value: 3 },
    { name: 'Symbian', value: 4 },
    { name: 'Window', value: 5 },
    { name: 'Mac', value: 6 },
    { name: 'Other', value: 7 }
];
export const DSP_TYPE_OPTIONS = [
    { name: '阿里东风', value: 23 },
    { name: '精准通', value: 25 },
    { name: '阿里TANX', value: 28 },
    { name: '苏宁', value: 41 },
    { name: '唯品会', value: 47 }
];
export const SIZE_TYPE_OPTIONS = [
    { name: '1080x720', value: '1080*720' },
    { name: '225x150', value: '225*150' },
    { name: '690x360', value: '690*360' },
    { name: '640x360', value: '640*360' },
    { name: '750x120', value: '750*120' },
    { name: '686x120', value: '686*120' }
];
export const TEMPLATE_TYPE_OPTIONS = [
    { name: '一图', value: 1 },
    { name: '三图', value: 2 }
];
export const SOURCE_TYPE_OPTIONS = [
    { name: '变色龙', value: 'cham' },
    { name: '广告主', value: 'adv' }
];
export const ADV_TYPE_OPTIONS = [
    { name: '列表信息流', value: 0 },
    { name: '内页信息流', value: 1 },
    { name: '金币广告位', value: 2 },
    { name: '互动广告位', value: 3 },
    { name: '视频tab-信息流', value: 4 },
    { name: '热文页信息流', value: 5 }
];
